import React, { useRef} from 'react';
import MicroModal from "micromodal";
import ReactPlayer from 'react-player';

const ModalVideo = (props) => {
  const { nombreModal, video } = props;
  const refVideo = useRef(null);

  const cerrarModal = () => {
    refVideo.current.getInternalPlayer().pauseVideo();
    MicroModal.close(nombreModal, {
      awaitCloseAnimation: true
    });
  }
  return (
    <div className="micromodal-slide" id={nombreModal} aria-hidden="true">
      <div className="modal__overlay">
        <div className="modal__container_video" role="dialog" aria-modal="true" aria-labelledby="modal-title">
          <button className="modal__cerrar icon-cerrar " onClick={cerrarModal }></button>
          <ReactPlayer
            ref={refVideo}
            url={video}
            height="100%"
            width="100%"
            controls
          />
        </div>
      </div>
    </div>
  )
}
export default ModalVideo;